'use client'
import React,{useState} from 'react';
import EmployAside from '../../aside';
import RechecherSociete from './rechercheSociete';

const ChecherSoc = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (
    
    <div className='main-page-wrapper'>
      
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>
      

      <RechecherSociete setIsOpenSidebar={setIsOpenSidebar}/>
      
    </div>   
  );
};

export default ChecherSoc;